import * as React from "react";
export class CurrentInning extends React.PureComponent {
    render() {
        return (React.createElement("span", { className: "rj-baseball-scoreboard-current-inning" }, `${this.props.currentInning}${this.props.partsPhrase} ${this.props.inningsPhrase}`));
    }
}
//# sourceMappingURL=CurrentInning.js.map